import { useState } from 'react';
import axios from '@common/axios';

const useAiExplanations = (conceptId) => {
    const [showExplanation, setShowExplanation] = useState({});
    const [explanations, setExplanations] = useState({});
    const [loadingExplanation, setLoadingExplanation] = useState({});
    const [currentExplanationIndex, setCurrentExplanationIndex] = useState({});
    const [feedbackStatus, setFeedbackStatus] = useState({});

    const loadAiExplanation = async (questionId) => {
        try {
            setLoadingExplanation(prev => ({ ...prev, [questionId]: true }));
            const response = await axios.get('/web/ui/question/explanations/explain', {
                params: { questionId, conceptId }
            });
            setExplanations(prev => ({ ...prev, [questionId]: response.data.explanations || [] }));
            setCurrentExplanationIndex(prev => ({ ...prev, [questionId]: 0 }));
            setShowExplanation(prev => ({ ...prev, [questionId]: true }));
        } catch (err) {
            console.error('Error loading explanation:', err);
        } finally {
            setLoadingExplanation(prev => ({ ...prev, [questionId]: false }));
        }
    };

    const toggleExplanation = (questionId) => {
        if (showExplanation[questionId]) {
            setShowExplanation(prev => ({ ...prev, [questionId]: false }));
        } else {
            if (!explanations[questionId]) loadAiExplanation(questionId);
            else setShowExplanation(prev => ({ ...prev, [questionId]: true }));
        }
    };

    const handleFeedback = async (questionId, isPositive, explanationId) => {
        try {
            setFeedbackStatus(prev => ({ ...prev, [questionId]: 'submitting' }));

            await axios.post('/web/ui/question/explanations/feedback/submit', null, {
                params: { questionId, helpful: isPositive, explanationId: explanationId || undefined, conceptId: conceptId || undefined }
            });

            setFeedbackStatus(prev => ({ ...prev, [questionId]: 'success' }));
        } catch (err) {
            console.error('Error submitting explanation feedback:', err);
            setFeedbackStatus(prev => ({ ...prev, [questionId]: 'error' }));
        }
    };

    const clearFeedbackStatus = (questionId) => {
        setFeedbackStatus(prev => {
            const next = { ...prev };
            delete next[questionId];
            return next;
        });
    };

    const resetExplanations = () => {
        setShowExplanation({});
        setExplanations({});
        setLoadingExplanation({});
        setCurrentExplanationIndex({});
        setFeedbackStatus({});
    };

    return {
        showExplanation, explanations, loadingExplanation, currentExplanationIndex, setCurrentExplanationIndex,
        toggleExplanation, handleFeedback, resetExplanations,
        feedbackStatus, clearFeedbackStatus
    };
};

export default useAiExplanations;
